<template>
    <div class="page-card">
        <div class="order-card__list">
            <order-card-component @click="isOrderTypeOpen" class="order-card_vertical" text="Создать заказ" size="70" name="paperAdd"/>
            <order-card-component @click="draftPush" class="order-card_vertical" text="Черновики" size="70" name="paperBig"/>
        </div>
        <order-list-short-component :link= true :quantity="5" />
        <order-local-list-component />
        <popup-component :mt="true" :isOpen="isOrderType" @close="(isOrderType = false)">
            <template #title>
                    Выберите тип заказа
            </template>
            <template #content>
                <div class="order-card__list order-card__list_popup">
                    <router-link class="order-card__link" :to="{ name: 'createOrder', query: { type: 'gravesLandscaping' } }">
                        <order-card-component class="order-card_horizontal" text="Благоустройство могилы" size="60" name="grave"/>
                    </router-link>
                    <router-link class="order-card__link" :to="{ name: 'createOrder', query: { type: 'monument' } }">
                        <order-card-component class="order-card_horizontal" text="Памятник" size="60" name="monument"/>
                    </router-link>
                </div>
            </template>
        </popup-component>
    </div>
</template>
<script setup lang="ts">
import orderCardComponent from '../shared/orderCardComponent.vue'
import popupComponent from '../entities/popupComponent.vue'
import orderListShortComponent from '../shared/orderListShortComponent.vue'
import orderLocalListComponent from '../shared/orderLocalListComponent.vue'
import { ref } from 'vue'
import router from '../app/router/router'

const isOrderType = ref(false)
const isOrderTypeOpen = () => isOrderType.value = true
const draftPush = () => router.push('draft')
</script>